// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2WWex","title":"ClientCherryInfo_title__3jA3w","itemText":"ClientCherryInfo_itemText__1fPVl"};